module.exports = __webpack_public_path__ + "static/media/P1010321 - Version 2.7200d62b.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/items/new/P1010321 - Version 2.JPG
// module id = 190
// module chunks = 0